<template>
  <div>
    <div class="card">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-2">
            <b-form-group label="Kỳ thống kê" class="mb-0">
              <v-select v-model="thongke" :options="dataThongke" label="name" :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-4 pl-0 pr-0" v-if="thongke == 1">
            <div class="optionDate">
              <b-form-group label="Năm" class="mb-0">
                <v-select v-model="year" :options="dataYear" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>

              <b-form-group label="Tháng" class="mb-0">
                <v-select v-model="month" :options="dataMonth" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>

            </div>
          </div>
          <div class="col-12 col-md-4" v-if="thongke == 2">
            <b-form-group label="Khoảng thời gian">
              <template #label>
                <label class="d-block font-weight-bolder">Khoảng thời gian</label>
              </template>
              <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
                :show-time-panel="false" format='DD/MM/YYYY' valueType="format"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>

            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group label="Kênh liên kết" class="mb-0">
              <v-select v-model="source_id" :options="dataSource" label="name" :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>

          <div class="sol-12 col-md-2">
            <div style="padding-top: 2rem">
              <b-button variant="primary" @click="updateSearchQuery">
                <feather-icon icon="SearchIcon" /> Tìm kiếm </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <b-table ref="refListTable" class="table-responsive table-nowrap" :items="dataItems" responsive
          :fields="tableColumns" primary-key="id" show-empty empty-text="No matching records found">
          <!-- Column: Status -->
          <template #cell(status)="data">
            <span v-if="data.item.status" class="badge badge-light-success">Đang kết nối</span>
            <span v-else class="badge badge-light-danger">Tạm dùng</span>
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" class="" variant="warning" @click="edit(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm" class="ms-2" variant="danger" @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
                entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import store from '@/store';
import { ref, computed, watch } from '@vue/composition-api';
import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BTable,
  BRow,
  BCol,
  BPagination,
} from 'bootstrap-vue';
import { showToast, useRouter } from '@core/utils/utils';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import moment from 'moment';
export default {
  components: {
    vSelect,
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    flatPickr,
    BTable,
    BRow,
    BCol,
    BPagination,
    DatePicker
  },
  data() {
    return {
      moment,
      dataThongke: [
        { id: 1, name: 'Tháng' },
        { id: 2, name: 'Khoảng thời gian' },
      ],
      dataSource: [
        { id: 1, name: 'TTXVN' },
        { id: 2, name: 'CNN' },
      ],
      dataMonth: [
        { id: 1, name: 'Tháng 1' },
        { id: 2, name: 'Tháng 2' },
        { id: 3, name: 'Tháng 3' },
        { id: 4, name: 'Tháng 4' },
        { id: 5, name: 'Tháng 5' },
        { id: 6, name: 'Tháng 6' },
        { id: 7, name: 'Tháng 7' },
        { id: 8, name: 'Tháng 8' },
        { id: 9, name: 'Tháng 9' },
        { id: 10, name: 'Tháng 10' },
        { id: 11, name: 'Tháng 11' },
        { id: 12, name: 'Tháng 12' },
      ],
    };
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const thongke = ref(1);
    const source_id = ref('');
    const start_date = ref('');
    const year = ref('');
    const month = ref('');
    const loading = ref(true);
    const end_date = ref('');
    const dataItems = ref([]);
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    const dateRange = ref(null)
    const loadDateRange = ref('')
    const now = new Date()
    const refListTable = ref(null);
    if (!year.value) {
      year.value = currentYear
    }
    if (!month.value) {
      month.value = currentMonth
    }
    // Table Handlers
    const tableColumns = [
      { key: 'id', sortable: false, class: 'itemid' },
      { key: 'name', sortable: false, label: 'Danh mục' },
      {
        key: 'source_name',
        sortable: false,
        label: 'Kênh liên kết',
        thAttr: { width: '15%' },
      },
      {
        key: 'total',
        sortable: false,
        label: 'Số lượng',
        thAttr: { width: '10%' },
      },
      {
        key: 'count',
        sortable: false,
        label: 'Số lượng tin đã tạo',
        tdAttr: { width: '10%', 'class': 'text-center' },
      },
    ];
    const fetchAll = () => {
      loading.value = true
      store
        .dispatch('crawlerConfig/fetchAll', {
          perPage: perPage.value,
          page: currentPage.value,
          style: 'statistic',
          year: year.value,
          month: month.value,
          source_id: source_id.value,
          start_date: start_date.value,
          end_date: end_date.value,
        })
        .then((response) => {
          loading.value = false;
          let result = response.data;
          if (result.code == 200) {
            total.value = result.total;
            dataItems.value = result.data.data;
          }
        });
    };
    fetchAll();
    const updateSearchQuery = () => {
      fetchAll();
    };
    watch([currentPage, perPage, source_id, start_date, end_date], () => {
      fetchAll();
    });

    let dataYear = ref([{ id: currentYear, name: currentYear }]);
    for (let i = 1; i < 10; i++) {
      let text = currentYear - i;
      dataYear.value.push({ id: text, name: text });
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])
    return {
      total,
      perPage,
      currentPage,
      tableColumns,
      loading,
      dataItems,
      thongke,
      source_id,
      start_date,
      end_date,
      updateSearchQuery,
      dataYear,
      year,
      month,
      loading,
      dataMeta,
      loadDateRange,
      shortcuts,
      dateRange
    };
  },
  methods: {},
};
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold;
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
